/**
 * Formatação da tela do leilão.
 *
 * Moeda sai de `src/helpers` como no resto do painel; o que fica aqui é só o que é desta tela:
 * o `—` para valor ausente, a variação sem centavos do telão e o horário do lance.
 */
import { formatCurrency } from '../../../../helpers'

const toNumber = (value: string | number | null | undefined): number | null => {
  if (value === null || value === undefined || value === '') return null
  const parsed = typeof value === 'string' ? parseFloat(value) : value
  return Number.isFinite(parsed) ? parsed : null
}

/** "R$ 8.512,00" — para listas e selos, onde os centavos importam. */
export const formatBRL = (value: string | number | null | undefined): string => {
  const parsed = toNumber(value)
  if (parsed === null) return '—'

  return formatCurrency(parsed)
}

/**
 * "R$ 85.000" — para o número gigante do telão, que fica ilegível cheio de zeros.
 *
 * Não é `formatCurrency`: este é o único lugar do painel que esconde os centavos quando o valor
 * é redondo, então a variação fica local em vez de virar mais uma opção do helper compartilhado.
 */
export const formatBRLShort = (value: string | number | null | undefined): string => {
  const parsed = toNumber(value)
  if (parsed === null) return '—'

  const hasCents = Math.round(parsed * 100) % 100 !== 0
  return `R$ ${parsed.toLocaleString('pt-BR', {
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2
  })}`
}

/** "10:14" — horário do lance no histórico ao vivo. */
export const formatBidTime = (isoDate: string | null | undefined): string => {
  if (!isoDate) return '--:--'

  const date = new Date(isoDate)
  if (Number.isNaN(date.getTime())) return '--:--'

  return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
}
